<template>
  <div class="catalog-search-bar">
    <div class="search-box">
      <svg class="search-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M21 21L15 15M17 10C17 13.866 13.866 17 10 17C6.13401 17 3 13.866 3 10C3 6.13401 6.13401 3 10 3C13.866 3 17 6.13401 17 10Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <input
        :value="value"
        type="text"
        :placeholder="placeholder"
        class="search-input"
        @input="$emit('input', $event.target.value)"
        @keyup.enter="$emit('search', value)"
      />
      <button
        v-if="value"
        type="button"
        class="search-clear"
        aria-label="Limpar busca"
        @click="clearSearch"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <line x1="18" y1="6" x2="6" y2="18"/>
          <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CatalogSearchBar',
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Buscar produtos e serviços...'
    }
  },
  methods: {
    clearSearch() {
      this.$emit('input', '')
      this.$emit('search', '')
    }
  }
}
</script>

<style scoped>
.catalog-search-bar {
  margin-bottom: 24px;
}

.search-box {
  position: relative;
  width: 100%;
  max-width: 100%;
}

.search-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 20px;
  color: #6b7280;
  pointer-events: none;
}

.search-input {
  width: 100%;
  padding: 14px 44px 14px 44px;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  font-size: 15px;
  background: #fff;
  color: #111827;
  font-family: inherit;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.search-input:focus {
  outline: none;
  border-color: #34894d;
  box-shadow: 0 0 0 2px rgba(52, 137, 77, 0.15);
}

.search-input::placeholder {
  color: #9ca3af;
}

.search-clear {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  padding: 4px;
  border: none;
  background: transparent;
  color: #6b7280;
  cursor: pointer;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search-clear:hover {
  color: #111827;
  background: #f3f4f6;
}
</style>
